export default {
  apiKey: 'AIzaSyCsUdvFP1yYx80TtAxDCCHHEW_KcowkNjM',
  authDomain: 'insider-53ef7.firebaseapp.com',
  databaseURL: 'https://insider-53ef7.firebaseio.com',
  projectId: 'insider-53ef7',
  storageBucket: 'insider-53ef7.appspot.com',
  messagingSenderId: '1095653283156'
}



// WEBPACK FOOTER //
// ./src/Firebase/firebaseConfig.js